import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import Add from '../../../../modal/Settings/Production_Management/ItemPropertyType/AddItemPropertyType';
import Edit from '../../../../modal/Settings/Production_Management/ItemPropertyType/EditItemPropertyType';
import EditItemPropertyType from '../../../../modal/Settings/Production_Management/ItemPropertyType/EditItemPropertyType';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';


const ItemPropertyType = () => {
    const baseURL = process.env.REACT_APP_API_BASE_URL; 
    const tableRef = useRef(null);
    const [page, setPage] = useState(1); 
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(10);
    const [propertyType, setPropertyType] = useState([]);
    const [open, setOpen] = useState(false); // Modal visibility state 
    const [modalType, setModalType] = useState("");
    const [total_entries, setTotslEntries] = useState(0);
    const [editModalShow, setEditModalShow] = useState(false);
    const [currentItemId, setCurrentDepartmentId] = useState(null); 
    const handleModalToggle = () => {
        setModalType("Add");  // Set the modal type to "Add"
        setOpen(true);  // Toggle the modal visibility
    };
    const handleModalToggle_Edit = () => {
        setModalType("Edit");  // Set the modal type to "Add"
        setOpen(true);
    }; 
    
    const handleModalDepartment_Edit = (propertyTypeId) => { 
        setEditModalShow(true);
        setCurrentDepartmentId(propertyTypeId);
    };

    const DeleteModal = (propertyTypeId, propertyTypeName) => {
        swal.fire({
            html: `
                <div class="alert alert-danger px-2 py-2" role="alert">
                    <strong>OOPS! </strong> You're about to delete this Department.
                </div>
                <p class="text-center"><b>${propertyTypeName}</b></p>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(`${baseURL}/propertytype/${propertyTypeId}`)
                    .then(() => {
                        // swal.fire({
                        //     title: 'Property Type Deleted!',
                        //     text: `${propertyTypeName}`,
                        //     icon: 'success', 
                        //     confirmButtonText: 'OK',
                        //     customClass: {
                        //         confirmButton: 'btn btn-sm btn-primary',
                        //     }
                        // });
                        
                        fetchPropertyType(); // Refresh table data
                        toast.success("Property Type Deleted successfully!");
                    })
                    .catch(error => {
                        console.error("Delete failed:", error);
                        // swal.fire("Error", "Failed to delete the property type.", "error");
                        toast.error("Delete Failed");
                    });
            } 
            // else {
            //     swal.fire({
            //         title: 'Delete Cancelled',
            //         text: `${propertyTypeName}`,
            //         icon: 'warning',
            //         confirmButtonText: 'OK',
            //         customClass: {
            //             confirmButton: 'btn btn-sm btn-primary',
            //         }
            //     });
            // }
        });
    };

    const fetchPropertyType = async (pageNumber = 1, perPageCount = 25, search = '') => {
        try {
            const response = await axios.get(`${baseURL}/propertytype`, {
                params: {
                    page: pageNumber,
                    per_page: perPageCount,
                    search: search,
                }
            }); 

            const data = response.data;
            setPropertyType(data.data || []);
            setTotslEntries(data.count);
            // Optional: store pagination data
            // setPagination(data.pagination);

        } catch (error) {
            console.error('Error fetching property type:', error);
        }
    };


    useEffect(() => {
        // fetchDepartments();
        fetchPropertyType(page, perPage, searchTerm);
    }, [page, searchTerm, perPage]);
    
    const handleStatusChange = (productTypeId, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;
    
        axios.put(`${baseURL}/propertytype/status/${productTypeId}`, { status: newStatus })
            .then(() => { 
                fetchPropertyType();
            })
            .catch(error => {
                console.error("Error updating status:", error);
            });
    };


    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Property Type</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item"><Link to='/settings'>Settings</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Production Management</li>
                    </ol>
                </div>
                <Button
                    className="btn btn-primary btn-sm"
                    onClick={handleModalToggle}
                >
                    <span className="me-2">
                        <i className="fa-solid fa-plus fs-8"></i>
                    </span>
                    <span>Add Property Type</span>
                </Button>
                {open && modalType === "Add" && (
                    <Add show={open} onClose={() => setOpen(false)} onCreated={fetchPropertyType}/>
                )}
                {open && modalType === "Edit" && (
                    <Edit show={open} onClose={() => setOpen(false)} />
                )}
            </div>
            <div className="table-container">
                 <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Left: Show entries dropdown */}
                    <div>
                        <label className="me-2">Show</label>
                        <select
                            className="form-select d-inline w-auto"
                            style={{  fontSize: '0.85rem', height: '30px' }}
                            value={perPage}
                            onChange={(e) => {
                                setPerPage(Number(e.target.value));
                                setPage(1); // Reset to first page
                            }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                    </div>

                    {/* Right: Search input */}
                   <div>
                        <input
                            type="text"
                            style={{ fontSize: '0.85rem', height: '40px' }}
                            placeholder="Search..."
                            className="form-control"
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setPage(1); // Reset to first page when searching
                            }}
                        />
                    </div>

                  </div>

                <table id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                    <thead>
                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                      
                            <th className='min-w-150px'>Property Type</th>
                            <th className='min-w-300px'>Description</th>
                            <th className='min-w-100px'>Status</th>
                            {/* <th className='min-w-100px'>Actions</th> */}
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7">
                        {propertyType.map((type, idx) => (
                            <tr key={type.sno}>
                               
                                <td>
                                    <label className='text-black font-w400 fs-7'>{type.propertytype_name}</label> 
                                </td>
                                <td>
                                    <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{type.description || "No description available."}</span></Tooltip>} >
                                        <div className='text-truncate mw-400px text-black font-w400 fs-7'>{type.description || "No description available."}</div>
                                    </OverlayTrigger>
                                </td>
                                <td>
                                    <div className="form-check form-switch d-flex align-items-center mb-3">
                                        <input
                                            className="form-check-input me-2"
                                            type="checkbox"
                                            role="switch"
                                            checked={type.status == 0}
                                            onChange={() => handleStatusChange(type.sno, type.status)}
                                        />
                                 </div>
                                </td>
                                {/* <td>
                                    <span class="text-end">
                                        <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                            <Button variant="primary tp-btn-light px-2 py-1 me-1" 
                                            // onClick={handleModalToggle_Edit}
                                            onClick={() => handleModalDepartment_Edit(type.sno)}
                                            >
                                                <span><i class="fa-solid fa-pen-to-square fs-6 mt-1"></i></span>
                                            </Button>
                                        </OverlayTrigger>
                                        <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delete</span></Tooltip>} >
                                            <Button variant="primary tp-btn-light px-2 py-1 me-1" 
                                            // onClick={DeleteModal}
                                            onClick={() => DeleteModal(type.sno, type.propertytype_name)}
                                            >
                                                <span><i class="fa-solid fa-trash-can fs-6 mt-1"></i></span>
                                            </Button>
                                        </OverlayTrigger>
                                    </span>
                                </td> */}
                            </tr>
                        ))}
                    </tbody>
                </table>

                   <div className="d-flex justify-content-between align-items-center mt-3">
                    {/* Bottom left: Showing x to y of z entries */}
                    <div>
                        {propertyType.length > 0 && (
                            <span className="text-muted">
                                Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + propertyType.length} of {total_entries} entries
                            </span>
                        )}
                    </div>

                    {/* Bottom right: Pagination */}
                    <nav>
                        <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                            <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                            </li>
                            {[...Array(totalPages)].map((_, i) => (
                            <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                            </li>
                            ))}
                            <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                            </li>
                        </ul>
                    </nav>

                </div>

                 <EditItemPropertyType
                    show={editModalShow}
                    onClose={() => setEditModalShow(false)}
                    propertyTypeId={currentItemId}
                    onUpdated={fetchPropertyType}
                />


            </div>
        </>
    )


}
export default ItemPropertyType;